export default "__VITE_ASSET__nYBB3Bt$__"